module.exports = __webpack_public_path__ + "static/media/cloudfront-logo.20b82ccb.png";